/* eslint-disable react/forbid-prop-types */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

import styles from './useStyles';
import Input from '../../../../../components/Input';
import { FovisssteData } from '../../../data';
import Simulator, {
  FRAME_CLASSES, FRAME_TYPES, isGreaterThanValue,
} from '../../Simulator';
import { determineMontoPrestamo } from '../../../../../utils/banksCalculations.utils';

import { INFONAVIT_COTIZACION_BUTTON_TEXT, INFONAVIT_FOVISSSTE_TYPE } from '../../../../../constants';

const {
  LIMIT_VALUE,
  TASA,
  INITIAL_VALUES,
  TASAS,
} = FovisssteData;

export const FovisssteSimulator = ({
  onSubmit, isVivienda,
  buttonTitle = INFONAVIT_COTIZACION_BUTTON_TEXT,
  initialValues = INITIAL_VALUES,
}) => {
  const classes = styles();

  const handleSubmit = ({
    monthlyPay,
    currentYear,
    values,
    event,
  }) => {
    const saldoSubcuentaInfonavit = values.saldoSubcuentaFovissste.value;
    const propietyValue = values.precio.value;
    const { enganche, montoPrestamo } = determineMontoPrestamo(
      INFONAVIT_FOVISSSTE_TYPE,
      propietyValue,
      0,
      0,
      saldoSubcuentaInfonavit,
    );

    const aforo = (montoPrestamo / values.precio.value).toFixed(4);
    const storageData = {
      saldoSubcuentaInfonavit: values.saldoSubcuentaFovissste.value,
      importe: montoPrestamo,
      meses: currentYear * 12,
      aforo,
      year: currentYear,
      plazo: `${currentYear} años`,
      mensualidad: monthlyPay,
      propietyValue: values.precio.value,
      enganche,
    };
    onSubmit({
      storageData,
      event,
    });
  };

  return (
    <Simulator
      initialData={initialValues}
      tasas={TASAS}
      TASA={TASA}
      onSubmit={handleSubmit}
    >
      {
        ({
          handleChange,
          values,
        }) => (
          <>
            <Simulator.InnerContainer isVivienda={isVivienda}>
              <Simulator.Frame variant={FRAME_TYPES.FRAME} frameClass={FRAME_CLASSES.FIRST_INPUT_ELEMENT}>
                <Input
                  label={values.precio.label}
                  type={values.precio.type}
                  name={values.precio.name}
                  value={values.precio.value}
                  required={values.precio.required}
                  isEmpty={values.precio.isEmpty}
                  validations={[
                    (inputValue) => isGreaterThanValue(inputValue, LIMIT_VALUE, 'Valor no puede ser menor a $1,200,000'),
                  ]}
                  onChange={handleChange}
                />
              </Simulator.Frame>
              <Simulator.Frame variant={FRAME_TYPES.FRAME} frameClass={FRAME_CLASSES.SECOND_INPUT_ELEMENT}>
                <Input
                  label={values.year.label}
                  type={values.year.type}
                  name={values.year.name}
                  value={values.year.value}
                  required={values.year.required}
                  isEmpty={values.year.isEmpty}
                  onChange={handleChange}
                  fullWidth
                  options={values.year.options}
                />
              </Simulator.Frame>
              <Simulator.Frame variant={FRAME_TYPES.FRAME} frameClass={FRAME_CLASSES.SECOND_INPUT_ELEMENT}>
                <Input
                  className={classes.inputElement}
                  classNameLabel={classes.blueColor}
                  label={values.saldoSubcuentaFovissste.label}
                  type={values.saldoSubcuentaFovissste.type}
                  name={values.saldoSubcuentaFovissste.name}
                  value={values.saldoSubcuentaFovissste.value}
                  required={values.saldoSubcuentaFovissste.required}
                  isEmpty={values.saldoSubcuentaFovissste.isEmpty}
                  onChange={handleChange}
                />
              </Simulator.Frame>
            </Simulator.InnerContainer>
            <Simulator.Button buttonTitle={buttonTitle} />
          </>
        )
      }
    </Simulator>
  );
};
FovisssteSimulator.propTypes = {
  onSubmit: PropTypes.func,
  isVivienda: PropTypes.bool,
  buttonTitle: PropTypes.string,
  initialValues: PropTypes.object,
};

FovisssteSimulator.defaultProps = {
  onSubmit: () => { },
  isVivienda: false,
  buttonTitle: INFONAVIT_COTIZACION_BUTTON_TEXT,
  initialValues: INITIAL_VALUES,
};
